import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

const CONSENT_KEY = 'echohill_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      setVisible(true);
    } else if (stored === 'accepted') {
      grantConsent();
    }
  }, []);

  function grantConsent() {
    if (window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
  }

  function handleAccept() {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    grantConsent();
    setVisible(false);
  }

  function handleDecline() {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
      <p className="cookie-banner__text">
        We use cookies to understand how visitors use this site (Google Analytics). No personal data is sold.{' '}
        <a href="/privacy" className="cookie-banner__link">Privacy Policy</a>
      </p>
      <div className="cookie-banner__actions">
        <button className="cookie-banner__btn cookie-banner__btn--decline" onClick={handleDecline}>
          Decline
        </button>
        <button className="cookie-banner__btn cookie-banner__btn--accept" onClick={handleAccept}>
          Accept
        </button>
      </div>
    </div>
  );
}
